var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBags(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.712,
    height: 33,
    viewBox: "0 0 25.712 33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    id: "Union_5",
    "data-name": "Union 5",
    d: "M-3976.956,33a2.977,2.977,0,0,1-2.154-.872A2.808,2.808,0,0,1-3980,30.06V9.948a5.938,5.938,0,0,1,1.575-4.111,6.309,6.309,0,0,1,3.892-2.081V0h3.846V3.644h7.086V0h3.846V3.756a6.314,6.314,0,0,1,3.893,2.081,5.94,5.94,0,0,1,1.574,4.111V30.06a2.811,2.811,0,0,1-.89,2.068,2.979,2.979,0,0,1-2.156.872Zm.283-26.078a4.055,4.055,0,0,0-1.3,3.026V30.06a.86.86,0,0,0,.283.645,1.022,1.022,0,0,0,.736.27h19.622a1.024,1.024,0,0,0,.738-.271.86.86,0,0,0,.283-.644V9.948a4.058,4.058,0,0,0-1.3-3.026,4.4,4.4,0,0,0-3.152-1.253h-12.754A4.4,4.4,0,0,0-3976.673,6.922Zm15.1,16.2v-3.5h-13.175V17.591h15.2v5.528h-2.026Z",
    transform: "translate(3980)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBags);
export default __webpack_public_path__ + "static/media/bags.793cd27dbf0832c135ebf8969364a482.svg";
export { ForwardRef as ReactComponent };